export class Guid {

    private constructor(private _value: string) { }

    public static new(): string {
        return this.createGuidString();
    }

    public isGuid(value: string): boolean {
        return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
    }

    private static createGuidString(): string {
        // Public Domain/MIT
        // https://stackoverflow.com/a/8809472/4173445
        let d = new Date().getTime(); //Timestamp
        let d2 = (performance && performance.now && (performance.now() * 1000)) ?? 0; //Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            var r = Math.random() * 16;//random number between 0 and 16
            if (d > 0) { //Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else { //Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
}
